import { defineNuxtRouteMiddleware, navigateTo, useCookie } from '#app'

// // middleware/i18n-prefix.global.ts
// export default defineNuxtRouteMiddleware((to, from) => {
//     // 支持的语言列表
//     const supportedLocales = ['zh-CN', 'en-US']
    
//     // 检查 URL 是否已经包含语言前缀
//     const hasValidPrefix = supportedLocales.some(lang => 
//       to.path.startsWith(`/${lang}/`) || to.path === `/${lang}`
//     )
    
//     // 如果已经有有效前缀，直接放行
//     if (hasValidPrefix) {
//       return
//     }
    
//     // 从 cookie 中获取当前语言（如果存在）
//     const cookieLang = useCookie('currentlang')?.value
    
//     // 确定要使用的语言：cookie 中的语言 > 默认语言
//     const defaultLocale = 'zh-CN'
//     const targetLocale = supportedLocales.includes(cookieLang) ? cookieLang : defaultLocale
    
//     // 构建新的 URL 路径
//     const newPath = `/${targetLocale}${to.path === '/' ? '' : to.path}`
    
//     // 重定向到带前缀的 URL
//     return navigateTo(newPath, { redirectCode: 301 })
//   })

// middleware/i18n-prefix.global.ts
export default defineNuxtRouteMiddleware((to) => {
  // 暂不开放英文站：客户端导航到 /en-US 时也跳中文
  if (to.path === '/en-US' || to.path.startsWith('/en-US/')) {
    // /en-US/weather|/en-US/forecast 也要像禁用入口一样，直接落到中文天气 App 页
    if (
      to.path === '/en-US/weather'
      || to.path === '/en-US/weather/'
      || to.path === '/en-US/forecast'
      || to.path === '/en-US/forecast/'
    ) {
      return navigateTo(
        { path: '/zh-CN/weather/APP', query: to.query, hash: to.hash },
        { redirectCode: 301 },
      )
    }
    const newPath = to.path.replace(/^\/en-US/, '/zh-CN') || '/zh-CN'
    return navigateTo(
      { path: newPath, query: to.query, hash: to.hash },
      { redirectCode: 301 },
    )
  }

  // 不开放 /weather|/forecast 首页入口：仅精确路径，weather 子路径放行
  if (
    to.path === '/weather'
    || to.path === '/weather/'
    || to.path === '/zh-CN/weather'
    || to.path === '/zh-CN/weather/'
    || to.path === '/en-US/weather'
    || to.path === '/en-US/weather/'
    || to.path === '/forecast'
    || to.path === '/forecast/'
    || to.path === '/zh-CN/forecast'
    || to.path === '/zh-CN/forecast/'
    || to.path === '/en-US/forecast'
    || to.path === '/en-US/forecast/'
  ) {
    return navigateTo(
      { path: '/zh-CN/weather/APP', query: to.query, hash: to.hash },
      { redirectCode: 301 },
    )
  }

  // 旧站城市/全球天气深链（/weather/china/...、/weather/world/...）→ 官网首页
  if (
    /^\/(?:zh-CN\/|en-US\/)?weather\/(china|world)(\/|$)/.test(to.path)
  ) {
    return navigateTo(
      { path: '/zh-CN', query: to.query, hash: to.hash },
      { redirectCode: 301 },
    )
  }

  // 支持的语言列表（英文站关闭期间仅中文）
  const supportedLocales = ['zh-CN']

  // 兼容旧站：/mojiweather/forecast.php 是接口请求
  // 直接返回（避免先被 i18n-prefix 301 到 /zh-CN/mojiweather/forecast.php）
  if (to.path === '/mojiweather/forecast.php') {
    return
  }

  // WAP 使用教程静态页：勿加语言前缀（App WebView 历史路径 /waphelp/*）
  if (to.path === '/waphelp' || to.path.startsWith('/waphelp/')) {
    return
  }

  // 旧站模板静态资源（如分享 logo）：勿加语言前缀
  if (to.path === '/templets' || to.path.startsWith('/templets/')) {
    return
  }

  // 旧首页文件名：避免 /zh-CN/index.html|/index.php 落到空白页
  if (
    to.path === '/index.html'
    || to.path === '/index.php'
    || to.path === '/zh-CN/index.html'
    || to.path === '/zh-CN/index.php'
  ) {
    return navigateTo(
      { path: '/zh-CN', query: to.query, hash: to.hash },
      { redirectCode: 301 },
    )
  }

  // 排除 404 路由，不强制加语言前缀
  if (to.path === '/404' || to.name === '404') {
    return
  }

  // 检查 URL 是否已经包含语言前缀
  const hasValidPrefix = supportedLocales.some(lang =>
    to.path.startsWith(`/${lang}/`) || to.path === `/${lang}`,
  )

  if (hasValidPrefix) {
    return
  }

  // 仅接受 zh-CN cookie，其余一律中文（避免 currentlang=en-US 再次跳英文）
  const cookieLang = useCookie('currentlang')?.value
  const defaultLocale = 'zh-CN'
  const targetLocale = cookieLang === 'zh-CN' ? 'zh-CN' : defaultLocale

  const newPath = `/${targetLocale}${to.path === '/' ? '' : to.path}`

  return navigateTo(newPath, { redirectCode: 301 })
})